import cookieService from '../../../../common/service/cookieService';
import { CustomWindow } from '../../../../common/utilities/custom.window';

declare let window: CustomWindow;

const adFixusService = {
  getAdFixusId: (): string | undefined => {
    const dataLayerId = window?.digitalData?.currentState?.user?.inchid?.acidPrid;
    if (dataLayerId) {
      return dataLayerId;
    }

    const adFixusCookieString = cookieService.getCookie('afx_profile');
    try {
      return JSON.parse(adFixusCookieString).acid;
    } catch (exception) {
      return undefined;
    }
  },
};

export default adFixusService;
